import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Dispatch } from 'redux'
import changeAdultsCount from '../../../actions/bookingCalendar/reservationModal/changeAdultsCount'
import mapObjectToFormSettings from '../../../models/Object/mappers/mapObjectToFormSettings'
import { IStore } from '../../../reducers'
import { getUserSettings } from '../../../reducers/userObject/selectors/settings'
import { toggleServicesModal } from '../../../actions/bookingCalendar/reservationModal/toggleServicesModal'
import { toggleProvenancesModal } from '../../../actions/provenances/toggleProvenancesModal'
import { addProvenance } from '../../../actions/provenances/addProvenance'
import changeChildrenCount from '../../../actions/bookingCalendar/reservationModal/changeChildrenCount'
import { changeReservationDate } from '../../../actions/bookingCalendar/reservationModal/changeReservationDate'
import { calculateEndPrice } from '../../../actions/bookingCalendar/reservationModal/calculateEndPrice'
import {
  getModalCreateReservaion,
  getModalReservationIsSaving,
} from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import onReservationFormChange from '../../../actions/bookingCalendar/reservationModal/onReservationFormChange'
import {
  getCreateReservationFormAdultsCount,
  getCreateReservationFormTotalAdultsCount,
  getCreateReservationModalRoom,
  getReservationFormVeryCurrentTab,
} from '../../../reducers/bookingCalendar/selectors/reservationForm'
import selectReservationTab from '../../../actions/bookingCalendar/reservationModal/selectReservationTab'
import {
  getActiveLicense,
  getInvoiceLicense,
  isLicenseValid,
} from '../../../reducers/userAccount/selectors/license'
import { FeedingType } from '../../../models/Object'
import validate, { shouldAsyncValidate } from './validate'
import { onSubmitCreate } from './submit'
import {
  ICreateReservationDispatch,
  ICreateReservationFormValues,
  ICreateReservationProps,
} from './CreateReservation'
import { FormNames } from './index'
import { ModalActions } from '../../../reducers/modals/actionNames'
import { fireToastError } from '../../../actions/toasts/fireToast'
import i18n from '../../../i18n/i18n'
import { PermissionScope } from '../../Employees'
import { isInScope } from '../../../hooks/useIsScope'
import { Mixpanel } from '../../../utils/Mixpanel'
import { isUserNewPackage } from '../../../reducers/userAccount/selectors/userAccount'

export default function(formName: string) {
  return reduxForm<ICreateReservationFormValues, ICreateReservationProps>({
    asyncValidate: validate(),
    destroyOnUnmount: true,
    enableReinitialize: false,
    form: formName,
    keepDirtyOnReinitialize: true,
    onChange: (nextValues, dispatch, props, prevValues) =>
      dispatch(
        onReservationFormChange(nextValues, prevValues, FormNames.Create),
      ),
    onSubmit: onSubmitCreate(formName),
    shouldAsyncValidate: shouldAsyncValidate,
    updateUnregisteredFields: true,
  })
}
const mapStateToProps = () => {
  return state => {
    const userValues = mapObjectToFormSettings(getUserSettings(state))
    const modal = getModalCreateReservaion(state)
    const room = getCreateReservationModalRoom(state)
    const adultsCount = getCreateReservationFormAdultsCount(state)
    const localTax = state.price.config.localTaxIncluded

    const scope = isInScope(state)
    return {
      initialValues: {
        additionalGuests: Array(adultsCount - 1).fill({}),
        adultsCount: adultsCount,
        children: [],
        childrenCount: 0,
        dateFrom: modal.from,
        feeding: userValues.feedingType
          ? userValues.feedingType
          : FeedingType.WithoutFood,
        guest: {},
        prepaymentType: userValues.prepaidType,
        registration: '0',
        reservationStatus: userValues.reservationStatus,
        roomId: modal.roomId ? modal.roomId : undefined,
        setCustomColor: false,
        singleBeds: room ? room.singleBed : undefined,
        twinBeds: room ? room.doubleBed : undefined,
        withoutTax: localTax,
      },
      allowConfig: scope([PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS]),
      allowFvat: scope([PermissionScope.SCOPE_CAN_USE_INVOICES]),
      allowTemplates: scope([PermissionScope.SCOPE_CAN_USE_TEMPLATES]),
      allowReservationEdit: scope([
        PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS,
      ]),
       hideUserData: scope([PermissionScope.SCOPE_HIDE_CLIENT_DATA]),
      licenseValid: isLicenseValid(state),
      licenseType: getActiveLicense(state),
      isNewPremiumPriceGroup: isUserNewPackage(state),
      invoice: getInvoiceLicense(state),

    }
  }
}

const mapStateToPropsStore = () => {
  return (state: IStore) => {
    const userValues = mapObjectToFormSettings(getUserSettings(state))

    return {
      formatDate: userValues.dateFormat,
      isSaving: getModalReservationIsSaving(state),
      premium: isLicenseValid(state),
      roomSize: getCreateReservationFormTotalAdultsCount(state),
      selectedTab: getReservationFormVeryCurrentTab(state),
      timeFrom: userValues.daynightFrom,
      timeTo: userValues.daynightTo,
      type: 'create',
    }
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps,
): ICreateReservationDispatch => ({
  addProvenance: (provenance: string) => dispatch(addProvenance(provenance)),
  calculate: () => dispatch(calculateEndPrice(FormNames.Create)),
  changeAdultsCount: (count: number) => dispatch(changeAdultsCount(count)),
  changeChildren: (count: number) =>
    dispatch(changeChildrenCount(count, FormNames.Create)),
  changeDates: (name: string, e: Date | number) =>
    dispatch(changeReservationDate(name, e, FormNames.Create)),
  refresh: () => null,
  closeTooltips: () => dispatch({ type: ModalActions.CloseTooltips }),
  selectTab: index => dispatch(selectReservationTab(index)),
  toggleProvenancesModal: (toggle?: boolean) => () =>
    dispatch(toggleProvenancesModal(toggle)),
  toggleServicesModal: (toggle?: boolean) => () =>
    dispatch(toggleServicesModal(toggle)),
  toggleHideModal: (toggle?: boolean) => {
    dispatch({ type: ModalActions.ToggleHideModal, payload: toggle })
  },
  firePricingError: () => {
    Mixpanel.track('Employee Access Denied', {
      'Employee ID': ownProps.workerId,
    })
    dispatch(fireToastError(i18n.t('BED_3621_no_permission')))
  },
})

export const withCreateInitialValues = connect(
  mapStateToProps(),
  mapDispatchToProps,
)

export const withState = connect(mapStateToPropsStore())
